import axios from 'axios';
import { url } from '../utils/api';


const basicAxiosInstance = axios.create({ baseURL: url });
const noTokenAxiosInstance = axios.create({ baseURL: url });

export {noTokenAxiosInstance, basicAxiosInstance};

